import { DefaultExposeGroupEnum } from '@goparrot/common';
import { DeleteExposeEnumGroup } from '../../common';
var CustomNotifierConfigurationExposeGroupEnum;
(function (CustomNotifierConfigurationExposeGroupEnum) {
    CustomNotifierConfigurationExposeGroupEnum["FIXTURE"] = "fixture";
})(CustomNotifierConfigurationExposeGroupEnum || (CustomNotifierConfigurationExposeGroupEnum = {}));
export const ConfigurationExposeGroup = Object.freeze({ ...DefaultExposeGroupEnum, ...CustomNotifierConfigurationExposeGroupEnum, ...DeleteExposeEnumGroup });
//# sourceMappingURL=ConfigurationExposeGroup.js.map